<div class="h-full w-full bg-grey-lightest p-5">
	<router-outlet></router-outlet>
</div>
